import { render, staticRenderFns } from "./DynamicCustomFields.vue?vue&type=template&id=33dd6e06&"
import script from "./DynamicCustomFields.vue?vue&type=script&lang=js&"
export * from "./DynamicCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports